import axios from 'axios';
import i18n from '../helpers/i18n';
import i18next from 'i18next';
import Player from './Player';

let ActivityManagerLoader = (function () {
  const generateContentImage = (srcImage) => {
    const contentBgImage = document.createElement('div');
    contentBgImage.classList.add('comet-screenreader-only');
    contentBgImage.style.background = `url(${srcImage}) no-repeat -9999px -9999px`;
    return contentBgImage;
  };

  const getPathFile = (pathFilename, hasDefault = false) => {
    try {
      if (hasDefault) return require('@/' + pathFilename).default;
      else return require('@/' + pathFilename);
    } catch (e) {
      return null;
    }
  };

  const getMedia = (filename) => {
    const fileMedia = getPathFile(filename, true);

    for (let i = 0; i < fileMedia.image.length; i++) {
      const img = new Image();
      const req = require(`@/${fileMedia.image[i].src}`);
      img.onload = () => {};
      img.src = req;
    }

    return {
      images: fileMedia.image || [],
      videos: fileMedia.video || [],
      audios: fileMedia.audio || [],
    };
  };

  const getData = (filename) => {
    return getPathFile(filename, true);
  };

  const checkImage = (image) => {
    return new Promise((resolve) => {
      const filename = getPathFile(image.src);

      axios
        .get(filename, {
          responseType: 'blob',
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: response.data.type });
          const urlCreator2 = window.URL || window.webkitURL;
          image.src = urlCreator2.createObjectURL(blob);
          image.srcBgUrl = filename;

          document.body.appendChild(generateContentImage(image.src));
          document.body.appendChild(generateContentImage(filename));

          resolve(image);
        })
        .catch(() => {
          resolve(image);
        });
    });
  };

  const checkAudio = (audio) => {
    return new Promise((resolve) => {
      const filename = getPathFile(audio.src);

      audio.src = new Player(filename);

      resolve(audio);
    });
  };

  const checkVideo = (media) => {
    return new Promise((resolve, reject) => {
      const filename = getPathFile(media.src);

      axios
        .get(filename, {
          responseType: 'blob',
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'video/mp4' });
          const urlCreator = window.URL || window.webkitURL;

          media.src = urlCreator.createObjectURL(blob);

          resolve(media);
        })
        .catch(() => reject);
    });
  };

  const loadImage = (paths) => Promise.all(paths.map(checkImage));
  const loadAudio = (paths) => Promise.all(paths.map(checkAudio));
  const loadVideo = (paths) => Promise.all(paths.map(checkVideo));

  const loadData = (data) => {
    const translate = function (collection) {
      if (typeof collection === 'object') {
        for (const property in collection) {
          collection[property] = translate(collection[property]);
        }

        return collection;
      } else if (Array.isArray(collection)) {
        collection.forEach((entry, index) => {
          collection[index] = translate(entry);
        });

        return collection;
      } else if (typeof collection === 'string') {
        const regex = new RegExp(/<language\b[^>]*>([\s\S]*?)<\/language>/gm);

        collection = collection.replace(regex, function (match, group) {
          return i18n.t(group);
        });

        return collection;
      }

      return collection;
    };

    return new Promise((resolve) => {
      if (!i18next.isInitialized) {
        i18next.on('initialized', () => {
          resolve(translate(data));
        });
      }
    });
  };

  class ActivityManagerLoader {
    constructor() {
      this.initial();
    }

    initial() {
      this.mediaSource = {
        images: [],
        audios: [],
        videos: [],
      };
      this.dataSource = [];

      this.media = {
        images: [],
        audios: [],
        videos: [],
      };
      this.data = [];
    }

    async load(resources) {
      try {
        if (!Object.keys(resources).length) {
          throw new Error('Activity Manager Failed');
        }

        this.moduleName = resources.moduleName.toLowerCase();
        this.mediaSource = getMedia(resources.media);
        this.dataSource = getData(resources.data);

        this.data = await loadData(this.dataSource);

        this.media.images = await loadImage(this.mediaSource.images);
        this.media.videos = await loadVideo(this.mediaSource.videos);
        this.media.audios = await loadAudio(this.mediaSource.audios);
      } catch (e) {
        throw new Error('Activity Manager Failed');
      }
    }

    getMediaById(type, mediaId) {
      let media = '';
      switch (type) {
        case 'image':
          media = this.media.images.find((image) => {
            return image.id === mediaId;
          });
          break;
        case 'audio':
          media = this.media.audios.find((audio) => {
            return audio.id === mediaId;
          });
          break;
        case 'video':
          media = this.media.videos.find((video) => {
            return video.id === mediaId;
          });
          break;
      }

      if (media === '' || media === undefined) {
        return '';
      }

      return media.src;
    }

    amountMediaSrc() {
      return (
        this.mediaSource.videos.length +
        this.mediaSource.audios.length +
        this.mediaSource.images.length +
        Object.keys(this.dataSource).length
      );
    }

    amountMedia() {
      return (
        this.media.videos.length +
        this.media.audios.length +
        this.media.images.length +
        Object.keys(this.data).length
      );
    }

    percentLoaded() {
      return (this.amountMedia() / this.amountMediaSrc()) * 100;
    }

    destroy() {
      this.initial();
    }
  }

  return ActivityManagerLoader;
})();

const ActivityManager = new ActivityManagerLoader();

export default ActivityManager;
